import { render } from "./blog-list-sidebar-right.vue?vue&type=template&id=64f07400"
import script from "./blog-list-sidebar-right.vue?vue&type=script&lang=js"
export * from "./blog-list-sidebar-right.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__